export type ResourceKind = 'skill' | 'teammate' | 'team' | 'userTool'

export type OperationOrigin = 'user' | 'assistant'

export type RoutineStatus = {
  resource?: ResourceKind
  id?: string
  dirty: boolean
}

export type PageRoutine<TDraft = unknown> = {
  status: () => RoutineStatus
  /** `origin` is `assistant` when the Workforce Assistant drove the save; it is sent as X-Torq-Change-Origin. */
  save?: (origin?: OperationOrigin) => Promise<{ id: string }>
  discard?: () => Promise<void>
  requestDelete?: (origin?: OperationOrigin) => Promise<void>
  fetchDraft?: () => Promise<TDraft>
}

export type RoutineSource = () => PageRoutine

export type RoutineFailure = 'validation' | 'conflict' | 'permission' | 'cancelled' | 'unsupported' | 'error'

export class RoutineError extends Error {
  readonly reason: RoutineFailure
  /** A machine-readable refinement of `reason`, e.g. `revision_conflict` for a stale If-Match. */
  readonly code?: string

  constructor(reason: RoutineFailure, message: string, code?: string) {
    super(message)
    this.name = 'RoutineError'
    this.reason = reason
    this.code = code
  }
}

export function routineFailureReason(error: unknown): RoutineFailure {
  return error instanceof RoutineError ? error.reason : 'error'
}
